export const breakpointsValues = {
  phone: 768,
  tablet: 992,
  desktop: 1200,
}

const breakpoints = {
  phone: `${breakpointsValues.phone}px`,
  tablet: `${breakpointsValues.tablet}px`,
  desktop: `${breakpointsValues.desktop}px`,
}

export default breakpoints
